export const SELECT_ALL = 'Mailboxes/Management/SELECT_ALL'
export const UNSELECT_ALL = 'Mailboxes/Management/UNSELECT_ALL'
